import { render, staticRenderFns } from "./VCadastroTelegram.vue?vue&type=template&id=3225ef58&"
import script from "./VCadastroTelegram.vue?vue&type=script&lang=js&"
export * from "./VCadastroTelegram.vue?vue&type=script&lang=js&"
import style0 from "./VCadastroTelegram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports